<template>
      <v-container 
        fluid
        fill-height
        id="app"
        tag="div"
        style="height: 80vh; max-height: 100%;">
        <small>El contenido que se muestra justo debajo es externo a LaCartaWeb.com y por tanto, no nos hacemos responsable del mismo.</small>
        <iframe width="100%" height="100%" :src="this.$store.state.LectorQRExt" frameborder="0" allowfullscreen scrolling="yes" style="overflow:hidden;"></iframe>
      </v-container>
</template>

<script>
    import store from '@/store/index';
    
    export default {
      name: 'LectorQRExt',
      data: () => ({
      }),
    }
</script>